var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArticleDetail = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 837,
  height: 400,
  viewBox: "0 0 837 400",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 837,
  height: 400,
  rx: 12,
  fill: "black",
  fillOpacity: 0.05
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M61 34C63.2091 34 65 35.7909 65 38V70C65 72.2091 63.2091 74 61 74H34C31.7909 74 30 72.2091 30 70V38C30 35.7909 31.7909 34 34 34H61Z",
  fill: "black",
  fillOpacity: 0.1
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M479 34C481.209 34 483 35.7909 483 38V58C483 60.2091 481.209 62 479 62H81C78.7909 62 77 60.2091 77 58V38C77 35.7909 78.7909 34 81 34H479Z",
  fill: "black",
  fillOpacity: 0.1
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M665 70C667.209 70 669 71.7909 669 74V80C669 82.2091 667.209 84 665 84H81C78.7909 84 77 82.2091 77 80V74C77 71.7909 78.7909 70 81 70H665Z",
  fill: "black",
  fillOpacity: 0.1
})));
export default SvgArticleDetail;